import { render, staticRenderFns } from "./singleprint.vue?vue&type=template&id=5ece79b0&scoped=true&"
import script from "./singleprint.vue?vue&type=script&lang=js&"
export * from "./singleprint.vue?vue&type=script&lang=js&"
import style0 from "./singleprint.vue?vue&type=style&index=0&id=5ece79b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ece79b0",
  null
  
)

export default component.exports